import { render, staticRenderFns } from "./SinglePolicy.vue?vue&type=template&id=a53ec614"
import script from "./SinglePolicy.vue?vue&type=script&lang=js"
export * from "./SinglePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports